import { CSSProperties } from 'react';

export const positionReference = [
  {
    top: '71%',
    right: '50px',
    transform: '0',
    color: 'var(--text-critical-dark-red)',
  },
  {
    top: '54%',
    right: '47px',
    transform: '35deg',
    color: 'var(--text-critical-dark-red)',
  },
  {
    top: '35%',
    right: '60px',
    transform: '70deg',
    color: 'var(--text-critical)',
  },
  {
    top: '23%',
    right: '87px',
    transform: '96deg',
    color: 'var(--text-critical)',
  },
  {
    top: '22%',
    right: '116px',
    transform: '126deg',
    color: 'var(--text-decorative-lime)',
  },
  {
    top: '29%',
    right: '144px',
    transform: '154deg',
    color: 'var(--text-decorative-lime)',
  },
  {
    top: '47%',
    right: '163px',
    transform: '183deg',
    color: 'var(--text-success)',
  },
  {
    top: '64%',
    right: '167px',
    transform: '219deg',
    color: 'var(--text-success)',
  },
];

const clampIndex = (value: number) =>
  Math.max(0, Math.min(positionReference.length - 1, value - 1));

export const getGaugePosition = (value: number) =>
  positionReference[clampIndex(value)];

export const getGaugeArrowStyle = (value: number): CSSProperties => {
  const position = getGaugePosition(value);
  return {
    transform: `rotate(calc(-200deg + ${position.transform})) translateX(50%) translateY(50%)`,
    top: position.top,
    right: `calc(100% - ${position.right})`,
  };
};
